export default __webpack_public_path__ + "static/media/scorpio.f324a3ab.png";